import React, { FC } from "react"
import { RRButtonFooter } from "../../atoms/roundedrectangle/RRButtonFooter"
import { Spacer } from "../../atoms/Atoms"
import { RRIconBar } from "../../atoms/roundedrectangle/RRIconBar"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import L10n from "../../../../lib/carrot-l10n"
import { BodyLarge, BodySmall } from "../../atoms/Bodies"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CarrotCardEligibleModule: FC<CarrotCardModuleProps> = ({ backgroundColor, isVirtualCard }) => (
  <RoundedRectangle backgroundColor={backgroundColor}>
    <RRIconBar iconBackgroundColor="white-60" iconName="icn-carrot-cards" />
    <BodyLarge color="black-80">{l`client.home.easilyPayForCare`}</BodyLarge>
    <Spacer height={0.5} />
    <BodySmall color="black-80">{l`client.home.theEasiestWayToPay`}</BodySmall>
    <RRButtonFooter to="/request-card" outline id="carrot-card-module-request-card">
      {isVirtualCard ? l`Get virtual card` : l`client.home.requestACard`}
    </RRButtonFooter>
  </RoundedRectangle>
)

export { CarrotCardEligibleModule }
